<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<div>
					<b-tabs content-class="mt-3">
						<b-tab title="Activities Logs" active>
							<h2>Historial de cambios</h2>
							<hr>
							<b-row class="filterwws">
								<b-form-group class="col-md-3" label="Modulo:">
									<b-form-select :options="optsModules" class="h-auto" v-model="filters.module"></b-form-select>
								</b-form-group>

								<b-form-group class="col-md-2" label="Id modulo:">
									<b-form-input  v-model="filters.moduleId" type="number" />
								</b-form-group>
								<b-form-group class="col-md-3" label="Fecha Inicio">
									<b-form-datepicker
											locale="es"
											reset-button
											v-model="filters.startDate"
									/>
								</b-form-group>

								<b-form-group class="col-md-3" label="Fecha fin">
									<b-form-datepicker
											locale="es"
											reset-button
											v-model="filters.endDate"
									/>
								</b-form-group>
								<b-form-group class="col-md-3" label="Usuarios">
									<multiselect
										v-model="filters.users"
										:options="usersOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-2" label=".">
									<b-button type="button" variant="primary" @click="search">Buscar</b-button>
								</b-form-group>
							</b-row>

							<AjaxTable
								permission-show="changelog.show"
								id="changelogs-index-list"
								:filters="filtersClean"
								:columns="modelColumns"
								resource="changelogs"
								responsive='md'
							>
								<template #cell(changes)="row">
									<span v-for="(change, i) in row.item.changes" :key="`${modelId}-${i}`">{{change}}<br/></span>
								</template>
							</AjaxTable>
						</b-tab>
						<b-tab title="Shuttle Central Api Logs">
							<api-logs-component></api-logs-component>
						</b-tab>
						<b-tab title="External Api Logs">
							<ExternalApiLogs/>
						</b-tab>
					</b-tabs>
				</div>
			</div>
			<hr>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Multiselect from 'vue-multiselect'
import ApiLogsComponent from "./ApiLogs.vue";
import ExternalApiLogs from "./ExternalApiLogs.vue";

export default {
	props: {
		modelId: {
			type : Number,
			required: false,
			default:-1
		}
	},
	components: { MainLayout, AjaxTable ,Multiselect,ApiLogsComponent, ExternalApiLogs},
	data(){
		return {
			filters : {
				search: '',
				module:'',
				moduleId:'',
				startDate:'',
				endDate:'',
				users:[]

			},
			modelColumns : [
				{key: 'id',				  label: 'ID'},
				{key: 'changeType',		  label: 'Modulo'},
				{key: 'changeId',		  label: 'Id Modulo'},
				{key: 'action',			  label: 'Accion'},
				{key: 'changes',		  label: 'Cambios'},
				{key: 'user',			  label: 'Usuario'},
				{key: 'creationDatetime', label: 'Fecha'},
			],
		}
	},
	methods: {
		search(){
			this.$root.$emit('bv::refresh::table', 'changelogs-index-list')
		}
	},
	computed:{
		filtersClean(){
			return {
				id:  this.modelId,
				module:this.filters.module,
				moduleId:this.filters.moduleId,
				startDate:this.filters.startDate,
				endDate:this.filters.endDate,
				users: this.filters.users.map((row)=>{return row.value})
			}
		},
		optsModules(){
			return [
				{value:"Suppliers",text:"Catalogo de proveedores"},
				{value:"ServiceTypes",text:"Catalogo de servicios"},
				{value:"PointOfSales",text:"Catalogo de puntos de venta"},
				{value:"SalesChannels",text:"Catalogo de canal de ventas"},
				{value:"Destinations",text:"Catalogo de ciudades"},
				{value:"Places",text:"Places"},
				{value:"Zones",text:"Catalogo de zonas"},
				{value:"RatePlans",text:"Planes tarifarios"},
				{value:"Prices",text:"Precios de planes tarifarios"},
				{value:"TransportUnits",text:"Vehiculos"},
				{value:"Payments",text:"Pagos"},
				{value:"users",text:"Usuarios"},
				{value:"ServiceTypesMapping",text:"Mapeo de tipos de servicio"}
			]
		},
		usersOpts(){
			return [{group:'SELECT ALL',options: this.$root.auxVars.usersOpts}]
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['usersOpts']})
	}
}
</script>

<style>

</style>
